import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { DamserviceService } from "../dam/damservice.service";
import { AuthService } from "angularx-social-login";
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { saveAs } from 'file-saver';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { SubscriptionService } from "../subscription/subscription.service";
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { UploadFilesService } from 'src/app/services/upload-files.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import AOS from 'aos';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private damService: DamserviceService,
    private authService: AuthService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private subscriptionService: SubscriptionService,
    private uploadService: UploadFilesService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  mobileViewSection: boolean = false;
  isMobile: any;

  profileSection: boolean = true
  showMyProjects: boolean = false;
  showMyUploads: boolean = true;
  showMyFollowers: boolean = false;
  showMoreOptions: boolean = false;

  isSelected: boolean[] = [true, false, false, false];
  showNoDataIllus: boolean = false;
  notifications = [];
  usersList = [];
  showSelectedEmoji: any;

  myUploadsImagesList = [];
  myUploadsImagesLength: any;

  currentUser: User;
  mobileView: boolean = false;
  workspaceId: any;
  workspaceName: string;
  userRole: string;
  userFullName: string;
  currentUserRating: any;
  planName: string;
  ownerEmail: String;
  ownerName: String;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  workspaceCountAllowed: any;
  totalWorkspaceCreated: any;
  planId: any;
  showLoader: boolean = false;
  showTopRightLoader: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;
  successfullMessage: string;
  sendSuccessfulMsg: boolean = false;
  showGenerateLinkError: boolean = false;
  linkErrorMsg: string;

  currentIllus: any;
  currentAssetId: any;
  currentIllusPosition: any;
  public selectedFormatIndex;
  imageDownloadShowFormat: any;
  showNextIcon: boolean = true;
  showPreviousIcon: boolean = true;
  isOpenWorkChecked: boolean = false;

  shareImageLink: any;
  fromAssets: boolean = false;
  teamListRatings: boolean = false;
  shareBoardId: any;
  shareLinkStyle = "none";
  shareProfileDetailsStyle = "none";
  shareReferralLinkStyle = "none";
  allowDownloads: any;
  showComments: any;
  allowComments: any;
  allowProjectsSelected: boolean = true;
  allowSocialsSelected: boolean = true;
  showCommentSelected: boolean = false;
  allowCommentingSelected: boolean = false;
  linkGenerated: boolean = false;
  expiryLinkIn: any = "f";
  showLinkCopied: boolean = false;
  sharedToken: any;
  imageSelected:boolean = false;
  changeColor= [false, false, false];
  downloadDelete:boolean = false;
  fileText: string;
  count: number = 0;
  imagesIdList: Array<{id: any, title: string}> = [];
  imagesIds: Array<{id: any}> = [];

  addProfileDetailsStyle = "none";
  addSocialsStyle = "none";
  addProjectsStyle = "none";
  addDesignationStyle = "none";

  showRewardsHistoryData: boolean = false;
  showMoreListItems: boolean = true;
  searchUser: string = '';

  stars: number[] = [1, 2, 3, 4, 5];
  selectedStar: number = 2;

  userTitle: any;
  userLocation: any;
  userBio: any;
  userApiTitle: any;
  userApiLocation: any;
  userApiBio: any;
  userTitleImg: Boolean = false;
  userLocationImg: Boolean = false;
  userBioImg: Boolean = false;
  userPic: any;
  linkedinLink: any;
  twitterLink: any;
  instagramLink: any;
  dribbbleLink: any;
  behanceLink: any;

  showTwitter: boolean = false;
  showInsta: boolean = false;
  showDribbble: boolean = false;
  showBehance: boolean = false;

  selectedFiles: FileList;
  userPictureUrl: string;

  selectedUserFiles: FileList;
  progressInfos = [];

  @ViewChild('imgMainModal') imgMainModal;

  addBioForm = this.fb.group({
    title: ['', Validators.required],
    location: [''],
    bio: [''],
  });

  addProjectsForm = this.fb.group({
    project: ['', Validators.required],
  });

  addDesignationForm = this.fb.group({
    designation: ['', Validators.required],
  });

  addSocialsForm = this.fb.group({
    linkedin: [''],
    twitter: [''],
    instagram: [''],
    dribbble: [''],
    behance: [''],
  });

  publicProfileShareLink: string;
  submitted: boolean = false;
  showLeaveLoader: boolean = false;
  showProfileDetailsLeaveLoader: boolean = false;
  showProjectsLeaveLoader: boolean = false

  emojis = [
    { emoji: '😐', number: 1 },
    { emoji: '🎉', number: 2 },
    { emoji: '🥉', number: 3 },
    { emoji: '🥈', number: 4 },
    { emoji: '🥇', number: 5 }
  ];

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    this.metaTagService.addTags([
      { name: 'description', content: 'Workspace profile that showcase your work via publish public or to anyone you want with just one shareable link.'},
      { name: 'keywords', content: 'profile, user profile, account, work, artwork, designs' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);
    if(this.currentUser) {
      this.getWorkspaceDetails();
    } else {
      this.router.navigate(['/login']);
    }

    AOS.init();

    if (this.isMobile) {
      this.mobileViewSection = true;
      this.profileSection = false;
      this.mobileView = true;
    }else{
      this.mobileViewSection = false;
      this.profileSection = true;
      this.mobileView = false;
    }
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
  }

  getCurrentUserData(workspaceId: any) {
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.userFullName = data.first_name + " " +data.last_name;
      this.currentUserRating = data.rating;
      this.titleService.setTitle(this.userFullName + "'s profile | Workspace | Crafttor");
      this.ownerListApi();
      this.getUserUploadedImages();
      this.getUserPic();
      this.getProfileData();
      this.getSocialData();
    },
    (error) => {
      if (this.currentUser) {
        if(error.status == 500){
        } else {

        }
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
      this.totalWorkspaceCreated = data.total_workspace_created;
    });
    this.userListApi();
  }

  userListApi(){
    this.damService.getUsersList(this.workspaceId).subscribe((data: any) => {
      if(data.length == 0) {
        this.teamListRatings = false;
      } else if(data.length > 0){
        this.teamListRatings = true;
        this.usersList = data;
      }
    });
  }

  mainClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId, workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam']);
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  openLoginScreen() {
    this.router.navigate(['/login']);
  }

  backToWorkspace() {
    this.router.navigate(['/dam']);
  }

  goToSubscription() {
    this.router.navigate(['/dam/subscription']);
  }

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent: PdfViewerComponent;
  pageRendered() {
    this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
  }

  allowShareProjects() {
    if(this.allowProjectsSelected) {
      this.allowProjectsSelected = false;
    } else {
      this.allowProjectsSelected = true;
    }
  }

  allowShareSocials() {
    if(this.allowSocialsSelected) {
      this.allowSocialsSelected = false;
    } else {
      this.allowSocialsSelected = true;
    }
  }

  hideSuccesfullFunction(){
    setTimeout(() => {
      this.showLinkCopied = false;
      this.sendSuccessfulMsg = false;
      this.sendSuccessfulErrorMsg = false;
    }, 3000);
  }

  projectsClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = true;
    this.showMyUploads = false;
    this.showMyFollowers = false;
    this.showMoreOptions = false;
  }

  myUploadsClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = false;
    this.showMyUploads = true;
    this.showMyFollowers = false;
    this.showMoreOptions = false;
    this.getUserUploadedImages();
  }

  follwoingClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = false;
    this.showMyUploads = false;
    this.showMyFollowers = true;
    this.showMoreOptions = false;
  }

  moreClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = false;
    this.showMyUploads = false;
    this.showMyFollowers = false;
    this.showMoreOptions = true;
  }

  openAddSocials(){
    this.addSocialsStyle = "block";
  }

  closeAddSocials(){
    this.addSocialsStyle = "none";
  }

  submitSocials() {
    this.submitted = true;
    if (this.addSocialsForm.valid) {
      this.googleAnalyticsService.event('socials_submitted', 'user_socials', this.currentUser.firstName +" "+this.currentUser.lastName);
      this.showProjectsLeaveLoader = true;
      this.linkedinLink = this.addSocialsForm.value['linkedin'];
      this.twitterLink = this.addSocialsForm.value['twitter'];
      this.instagramLink = this.addSocialsForm.value['instagram'];
      this.dribbbleLink = this.addSocialsForm.value['dribbble'];
      this.behanceLink = this.addSocialsForm.value['behance'];
      this.damService.submitSocialData(this.linkedinLink, this.twitterLink,
        this.instagramLink, this.dribbbleLink, this.behanceLink).subscribe((data: any) => {
        // this.addSocialsForm.reset();
        this.closeAddSocials();
        this.showProjectsLeaveLoader = false;
        this.getSocialData();
      },(error: any) => {
        if(error.status == 400){
          this.showProjectsLeaveLoader = false;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunction();
        } else {
          this.showProjectsLeaveLoader = false;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunction();
        }
     });
    }
  }

  openAddBioDialog(){
    this.addProfileDetailsStyle = "block";
  }

  closeAddBioDialog(){
    this.addProfileDetailsStyle = "none";
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.userPic = "";
        this.userPictureUrl = reader.result as string;
        this.currentUser.photoUrl = this.userPictureUrl;
      };
    }

    const files = event.target.files;
    let isImage = true;
    for (let i = 0; i < files.length; i++) {
      if (files.item(i).type.match('image.*')) {
        continue;
      } else {
        isImage = false;
        alert('Invalid Format!');
        break;
      }
    }

    if (isImage) {
      this.selectedFiles = event.target.files;
      this.uploadFiles();
    } else {
      this.selectedFiles = undefined;
      event.srcElement.percentage = null;
    }
  }

  uploadFiles(): void {
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.submitUserPic(this.selectedFiles[i]);
    }
  }

  submitUserPic(userPic: any) {
    this.showTopRightLoader = true;
    this.damService.submitUserPicData(userPic).subscribe((data: any) => {
      this.getUserPic();
      this.showTopRightLoader = false;
    },(error: any) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
      } else {
        this.showTopRightLoader = false;
      }
   });
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  submitUserBio() {
    this.submitYourBio()
  }

  submitYourBio() {
    this.submitted = true;
    if (this.addBioForm.valid) {
      this.googleAnalyticsService.event('user_bio_submitted', 'user_bio', this.currentUser.firstName +" "+this.currentUser.lastName);
      this.showProfileDetailsLeaveLoader = true;
      this.userTitle = this.addBioForm.value['title'];
      this.userLocation = this.addBioForm.value['location'];
      this.userBio = this.addBioForm.value['bio'];
      this.damService.submitProfileData(this.userTitle, this.userLocation, this.userBio).subscribe((data: any) => {
        this.addBioForm.reset();
        this.closeAddBioDialog();
        this.showProfileDetailsLeaveLoader = false;
        this.getProfileData();
      },(error: any) => {
        if(error.status == 400){
          this.addBioForm.reset();
          this.closeAddBioDialog();
          this.showProfileDetailsLeaveLoader = false;
        } else {
          this.addBioForm.reset();
          this.closeAddBioDialog();
          this.showProfileDetailsLeaveLoader = false;
        }
     });
    }
  }

  openAddProjectsDialog(){
    this.addProjectsStyle = "block";
  }

  closeAddProjectsDialog(){
    this.addProjectsStyle = "none";
  }

  submitYourProjects() {
    this.submitted = true;
    if (this.addProjectsForm.valid) {
      this.showLeaveLoader = true;

    }
  }

  openDesignationStyle() {
    this.addDesignationStyle = "block";
  }

  closeDesignationStyle() {
    this.addDesignationStyle = "none";
  }

  submitYourDesignation() {
    this.submitted = true;
    if (this.addDesignationForm.valid) {
      this.showLeaveLoader = true;
      this.addProjectsForm.reset();
      this.closeDesignationStyle();
      this.showLeaveLoader = false;
      // this.title = this.addBioForm.value['title'];
      // this.location = this.addBioForm.value['location'];
      // this.description = this.addBioForm.value['description'];
    }
  }

  starState(star: number) {
    return star <= this.selectedStar ? 'assets/img/star-golden.svg' : 'assets/img/star-black.svg';
  }

  viewRewards() {
    this.showRewardsHistoryData = true;
    this.showMoreListItems = false;
  }

  viewWorkHistory() {
    this.showRewardsHistoryData = true;
    this.showMoreListItems = false;
  }

  showMainMoreSection() {
    this.showRewardsHistoryData = false;
    this.showMoreListItems = true;
  }

  onSubmitUser() {

  }

  openPublicDialog() {
    this.googleAnalyticsService.event('go_public_dialog_opened', 'go_public_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.shareProfileDetailsStyle = "block";
  }

  closePublicDialog() {
    this.shareProfileDetailsStyle = "none";
  }

  openGetReferralLinkDialog() {
    this.googleAnalyticsService.event('referral_link_opened', 'referral_link_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.shareReferralLinkStyle = "block";
  }

  closeGetReferralLinkDialog() {
    this.shareReferralLinkStyle = "none";
  }

  publishProfile(inputElement) {
    this.googleAnalyticsService.event('publish_clicked', 'profile_go_public', this.currentUser.firstName +" "+this.currentUser.lastName);
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    window.open(this.publicProfileShareLink, "_blank");
  }

  copyReferralLink(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.showLinkCopied = true;
    this.hideSuccesfullFunction();
  }

  getProfileData() {
    this.damService.getProfileData().subscribe((data: any) => {
      this.userApiTitle = data.title;
      this.userApiLocation = data.location;
      this.userApiBio = data.bio;
      this.userTitle = data.title;
      this.userLocation = data.location;
      this.userBio = data.bio;
      if(this.userApiTitle == "" || this.userApiTitle == null) {
        this.userTitleImg = false;
      } else {
        this.userTitleImg = true;
      }
      if(this.userApiLocation == "" || this.userApiLocation == null) {
        this.userLocationImg = false;
      }else {
        this.userLocationImg = true;
      }
      if(this.userApiBio == "" || this.userApiBio == null) {
        this.userBioImg = false;
      } else {
        this.userBioImg = true;
      }
    });
  }

  getSocialData() {
    this.damService.getSocialData().subscribe((data: any) => {
      this.linkedinLink = data.linkdin_link;
      this.twitterLink = data.twitter_link;
      this.instagramLink = data.instagram_link;
      this.dribbbleLink = data.dribble_link;
      this.behanceLink = data.behance_link;
    });
  }

  hideSuccesfullFunctionErrorDelete(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 5000);
  }

  openFigma() {
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  getNotifications() {
    this.showLoader = true;
    this.newNotification();
  }

  newNotification () {
    this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
      this.notifications = data['notifcation'];
      this.showLoader = false;
    });
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  generatePublishLink() {
    this.getUserPublicProfileLink();
  }

  getUserPublicProfileLink() {
    this.googleAnalyticsService.event('generate_public_link', 'link_generated', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.linkErrorMsg = '';
    this.showGenerateLinkError = false;
    this.showLeaveLoader = true;
    this.damService.getUserPublicProfileLink(this.allowProjectsSelected,
       this.allowSocialsSelected).subscribe((data: any) => {
      this.publicProfileShareLink = data.link;
      this.showLeaveLoader = false;
      this.linkGenerated = true;
    },
    (error: any) => {
      if(error.status == 400){
        this.showLeaveLoader = false;
        this.showTopRightLoader = false;
        this.showGenerateLinkError = true;
        this.linkErrorMsg = error.error.message;
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showLeaveLoader = false;
        this.showTopRightLoader = false;
        this.showGenerateLinkError = true;
        this.linkErrorMsg = error.error.message;
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteUserSingleUploadedImages(assetId: any) {
    this.imagesIds.push(assetId);
    const idsString = this.imagesIds.join(',');
    this.damService.deleteUserUploadedImages(idsString).subscribe((data: any) => {
      this.cancelImageSelection();
      this.getUserUploadedImages();
    });
  }

  deleteUserUploadedImages() {
    const idsString = this.imagesIds.join(',');
    this.damService.deleteUserUploadedImages(idsString).subscribe((data: any) => {
      this.cancelImageSelection();
      this.getUserUploadedImages();
    });
  }

  getUserUploadedImages() {
    this.showTopRightLoader = true;
    this.damService.getUserUploadedImages().subscribe((data: any) => {
      this.showTopRightLoader = false;
      if(data['results'].length == 0){
        this.showNoDataIllus = true;
      }else{
        this.showNoDataIllus = false;
        this.myUploadsImagesList = data['results'];
        this.myUploadsImagesLength = data['results'].length;
      }
    });
  }

  selectUserFiles(event): void {
    this.progressInfos = [];

    const files = event.target.files;
    let isImage = true;
    for (let i = 0; i < files.length; i++) {
      if (files.item(i).type.match('application.*') || files.item(i).type.match('pdf.*') ||
      files.item(i).type.match('image.*') || files.item(i).type.match('video.*')) {
        continue;
      } else {
        isImage = false;
        alert('Invalid Format!');
        break;
      }
    }

    if (isImage) {
      this.selectedUserFiles = event.target.files;
      this.uploadUserFiles(event);
    } else {
      this.selectedUserFiles = undefined;
      event.srcElement.percentage = null;
    }
  }

  uploadUserFiles(event): void {
    for (let i = 0; i < this.selectedUserFiles.length; i++) {
      this.uploadUserImages(i, this.selectedUserFiles[i]);
    }
  }

  uploadUserImages(idx, file): void {
    this.showTopRightLoader = true;
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    this.uploadService.uploadUserProjectImages(file, file.name).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          this.showTopRightLoader = false;
          this.getUserUploadedImages();
        }
      },
      (error: any) => {
        if(error.status == 400){
          this.showTopRightLoader = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.showTopRightLoader = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
  }

  showDeleteButtons(ivalue: any, i: any, imageId: any, titles: string){
    this.downloadDelete = true;
    this.imageSelected = true;
    if(ivalue == false){
      this.count--;
      if(this.count < 1){
        this.count = 0;
        this.imageSelected = false;
        this.downloadDelete = false;
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
      }
      if(this.count <= 1){
        this.fileText = 'file';
      }else{
        this.fileText = 'files';
      }
      let index = this.imagesIds.indexOf(imageId);
      if (index !== -1) {
        this.imagesIds.splice(index, 1);
        this.imagesIdList.splice(index, 1);
      }
    }else{
      this.count++;
      if(this.count <= 1){
        this.fileText = 'file';
      }else{
        this.fileText = 'files';
      }
      this.imagesIds.push(imageId);
      this.imagesIdList.push({id: imageId, title: titles});
    }
  }

  cancelImageSelection(){
    this.count = 0;
    this.imageSelected = false;
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.imagesIds = [];
    this.changeColor = [];
  }

  goToLibrary() {
    this.googleAnalyticsService.event('library_click_profile_screen_click', 'library_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.router.navigate(['/library']);
  }

  selectedNumber: number | undefined;

  onSelectEmoji(number: number, index: number, userId: any) {
    this.usersList[index].selectedEmoji = number;
    const selectedNumber = this.usersList[index].selectedEmoji;
    const selectedEmoji = this.emojis.find(emoji => emoji.number === selectedNumber);
    this.showSelectedEmoji = selectedEmoji ? selectedEmoji.emoji : '';
    this.submitTeamUserRatingApi(userId, selectedNumber);
  }

  submitTeamUserRatingApi(userId: any, userRating: any){
    this.showTopRightLoader = true;
    this.damService.teamUserRatings(this.workspaceId, userId, userRating).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.userListApi();
    },(error: any) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunction();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunction();
      }
   });
  }

  openImgDialog(modal, imgName: string, imgPosition: any,
    currentAssetId: any, format: any){
    this.currentAssetId = currentAssetId
    this.currentIllusPosition = imgPosition;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = format;
    if(imgPosition == this.myUploadsImagesList.length-1) {
      this.showNextIcon = false;
      this.showPreviousIcon = true;
    } else if(imgPosition == 0){
      this.showPreviousIcon = false;
      this.showNextIcon = true;
    } else {
      this.showPreviousIcon = true;
      this.showNextIcon = true;
    }
    this.imgMainModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  nextImage(currentIllusPos: any) {
    this.showNextIcon = true;
    this.showPreviousIcon = true;
    this.selectedFormatIndex = 0;
    if(currentIllusPos == this.myUploadsImagesList.length-2) {
      this.showNextIcon = false;
    }
    if(currentIllusPos <= this.myUploadsImagesList.length-2) {
      for(var i = 0 ; i < this.myUploadsImagesList.length ; i++) {
        this.currentIllus = this.myUploadsImagesList[currentIllusPos+1];
      }
      this.currentIllusPosition = currentIllusPos+1;
    } else {
      //
    }
  }

  previousImage(currentIllusPos: any) {
    this.showNextIcon = true;
    this.showPreviousIcon = true;
    this.selectedFormatIndex = 0;
    if(currentIllusPos == 0) {
      this.showPreviousIcon = false;
    } else {
      for(var i = 0 ; i < this.myUploadsImagesList.length ; i++) {
        this.currentIllus = this.myUploadsImagesList[currentIllusPos-1];
      }
      this.currentIllusPosition = currentIllusPos-1;
    }
  }
}
